module.exports = __webpack_public_path__ + "img/tklingenhof2.6ceaadd1.jpg";